/**
 * BulkActionsBar — sticky toolbar che appare quando ≥1 riga è selezionata
 * nelle list admin (Aziende/Utenti). Mostra count + bottoni azioni bulk.
 *
 * Admin SUPER-MVP M3 (27/05/26): adesso solo 1 azione (Elimina selezionati).
 * Espandibile in futuro con bulk extend-trial, bulk grant-unlimited, ecc.
 */
import { Trash2, X } from 'lucide-react';

import { Button } from '@/components/ui/button';

export interface BulkActionsBarProps {
  count: number;
  entityLabel: string; // "aziende" / "utenti"
  onClearSelection: () => void;
  onBulkDelete: () => void;
  busy?: boolean;
}

export function BulkActionsBar({
  count,
  entityLabel,
  onClearSelection,
  onBulkDelete,
  busy = false,
}: BulkActionsBarProps) {
  if (count === 0) return null;

  return (
    <div className="sticky top-0 z-30 -mx-4 px-4 py-2 bg-primary/10 border-b border-primary/30 backdrop-blur-sm flex items-center gap-3">
      <Button variant="ghost" size="icon" className="h-7 w-7" onClick={onClearSelection} disabled={busy} aria-label="Deseleziona">
        <X className="h-4 w-4" />
      </Button>

      <span className="text-sm font-medium flex-1">
        {count} {count === 1 ? entityLabel.slice(0, -1) : entityLabel} selezionate
      </span>

      <Button
        variant="destructive"
        size="sm"
        onClick={onBulkDelete}
        disabled={busy}
        className="gap-1.5"
      >
        <Trash2 className="h-3.5 w-3.5" />
        Elimina selezionati
      </Button>
    </div>
  );
}
